import { getFunnelFunctionLibraries } from 'API/linkedin-funnel-funnel-function-library';
import { FunnelFunctionLibrary, FunnelFunctions, FunnelTypes } from 'features/co-pilot/co-pilot.types';
import { useUserData } from 'hooks/use-user-data';
import _ from 'lodash';
import useErrorStore from 'stores/error-store';
import usePromptLibraryStore from 'stores/prompt-library-store';
import { OptionType } from '../../ui/base-components/pai-auto-complete';

const usePromptLibrary = () => {
  useUserData();
  const handleOpenErrorDialog = useErrorStore((state) => state.handleOpenErrorDialog);

  const { promptLibraryOptions, campaignFunctions, setPromptLibraryOptions, setCampaignFunctions } = usePromptLibraryStore((state) => ({
    promptLibraryOptions: state.promptLibraryOptions,
    campaignFunctions: state.campaignFunctions,
    setPromptLibraryOptions: state.setPromptLibraryOptions,
    setCampaignFunctions: state.setCampaignFunctions,
  }));

  const fetchFunnelFunctionLibraries = async (campaignType: FunnelTypes): Promise<FunnelFunctionLibrary[] | undefined> => {
    const res = await getFunnelFunctionLibraries(campaignType);

    if (!res.error) {
      const options: OptionType[] = res.linkedInFunnelFunctionsLibraries.map((library: FunnelFunctionLibrary) => ({
        label: library.name,
        value: library.name,
      }));

      setPromptLibraryOptions(options);

      return res.linkedInFunnelFunctionsLibraries;
    } else {
      handleOpenErrorDialog(res?.error, '/ai/function-libraries', 'get');
    }

    return undefined;
  };

  const initCampaignFunctions = async (campaignType: FunnelTypes, selectedLibraryName: string) => {
    const libraries = await fetchFunnelFunctionLibraries(campaignType);

    if (!_.isNil(libraries)) {
      // Fallback to the first available library if the stored name no longer matches.
      const selectedLibrary = libraries.find((library) => library.name === selectedLibraryName) || libraries[0];
      const functions = selectedLibrary?.functions.filter((func) => func.functionName !== FunnelFunctions.CHECK_REPLY) || [];

      setCampaignFunctions(functions);
    }
  };

  const resetPromptLibraries = () => {
    setPromptLibraryOptions(null);
    setCampaignFunctions(null);
  };

  return {
    promptLibraryOptions,
    campaignFunctions,
    initCampaignFunctions,
    resetPromptLibraries,
  };
};

export default usePromptLibrary;
